import React from 'react'
import { ActivityIndicator } from 'react-native'

import { Stack } from '@zet/design-system'

const ListFooter = () => {
  return (
    <Stack className="h-[50]">
      <ActivityIndicator
        style={{ marginTop: 18 }}
        size={'large'}
        color="#2075F0"
      />
    </Stack>
  )
}

export default ListFooter
